import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../api/client';
import type { TenantCoverageResponse } from '../api/types';

/**
 * Rank-11 ATT&CK navigator — tenant-wide ATT&CK coverage map.
 *
 * Backed by the bas service (`services/bas/handler.py#getTenantCoverage`):
 *   GET /coverage/tenant → getTenantCoverage (instructor-readable)
 *
 * Where `useCoverage` reads one range's matrix, this reads the whole tenant's:
 * the bas Lambda aggregates every range's per-technique rows into one
 * best-verdict cell per technique (detected > prevented > missed > errored
 * across the fleet) + a headline summary. The ATT&CK Coverage navigator page
 * feeds the same reusable AttackCoverageMatrix with this aggregate.
 */

const tenantCoverageKey = ['bas-coverage', 'tenant'] as const;

export function useTenantCoverage(enabled = true) {
  return useQuery<TenantCoverageResponse>({
    queryKey: tenantCoverageKey,
    enabled,
    staleTime: 30_000,
    queryFn: async ({ signal }) =>
      apiFetch<TenantCoverageResponse>('/coverage/tenant', {
        method: 'GET',
        signal,
      }),
  });
}
